import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
//import '../css/UpdateUserProfile.css';
import axios from "axios";
import CustomHeader from "../components/Header";
import { CardDeck, Row, Col, Container, Card, Button } from "react-bootstrap";
import HomeVehicle from "../components/HomeVehicle";
import VehicleHealthComponent from "../components/VehicleHealthComponent";
import Select from "react-select";
import axiosConfig from "../config/axiosConfig";
import Stepper from "react-stepper-horizontal";
import AdvanceTableWithDeleteButton from "../components/Tables/AdvanceTableWithDeleteButton";
import ReminderAlert from "../components/ReminderAlert";
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { isElementOfType } from "react-dom/cjs/react-dom-test-utils.production.min";

const todayDate = new Date();

const headers = {
  "Content-Type": "application/json",
  APIkey: "C5BFF7F0-B4DF-475E-A331-F737424F013C",
};

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "black" : "black",
    backgroundColor: state.isSelected ? "#7367f0" : "white",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "20px",
    borderColor: "#7367f0",
  }),
};

class VehicleManagement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Others: "",
      middleName: "",
      lastName: "",
      email: "",
      mobileNo: "",

      groups: [],
      vrnOptions: [],
      steps: [
        {
          title: "Step One",
          // href: "http://example1.com",
          onClick: (e) => {
            e.preventDefault();
            console.log("onClick", 1);
          },
        },
        {
          title: "Step Two",
          // href: "http://example2.com",
          onClick: (e) => {
            e.preventDefault();
            console.log("onClick", 2);
          },
        },

        {
          title: "Step Three",
          // href: "http://example2.com",
          onClick: (e) => {
            e.preventDefault();
            console.log("onClick", 3);
          },
        },

        {
          title: "Step Four",
          // href: "http://example2.com",
          onClick: (e) => {
            e.preventDefault();
            console.log("onClick", 4);
          },
        },
      ],
      currentStep: 0,
      msgSpeeding: 0,
      regNo: '',
      manufacturer: '',
      vehicleName: '',
      vehicleModelYear: '',
      vehicleEngineChasisNo: '',
      currentOdo: '',
      maintenanceActivity: [],
      activityText: '',
      allselectedEmailIds: [],
      newselectedEmailId: [],
      newselectedSMSId: [],
      allSelectedSMSAndEmailsID: [],

      VRNMappingId: '',
      ActivityId: '',
      ActivityDate: '',
      ReminderOdometer: '0',
      ReminderDate: '',
      Comments: '',
      OthersActivity: true,
      OthersActivityComments: '',
      AvglastOdometerReading: '',
      IsPushAlert: false,
      IsEmailChecked: false,
      IsSMSChecked: false,
      mindate: '',
      selectedVehicle: '',

      createdDate:'',

    };

    this.changeHandler = this.changeHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.changeGroup = this.changeGroup.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrevious = this.onClickPrevious.bind(this);
    this.changeVRN = this.changeVRN.bind(this);
    this.onActivityChange = this.onActivityChange.bind(this);
    this.callbackfunction_SMSalert = this.callbackfunction_SMSalert.bind(this);
    this.callbackfunction_Emailalert = this.callbackfunction_Emailalert.bind(this);
    this.changeHandler_GetLastOdometerReading = this.changeHandler_GetLastOdometerReading.bind(this);
    this.callbackfunction_PushAlert = this.callbackfunction_PushAlert.bind(this);
    this.SetSMSCheck = this.SetSMSCheck.bind(this);
    this.SetEmailCheck = this.SetEmailCheck.bind(this);
    this.changeHandlerDate = this.changeHandlerDate.bind(this);
    this.setTodayDate = this.setTodayDate.bind(this);
  }

  async setTodayDate() {


    let year = todayDate.getUTCFullYear()
    let month = todayDate.getUTCMonth() + 1;
    if (month < 10) { month = "0" + month }
    let day = todayDate.getDate()

    let _today = year + '-' + month + '-' + day;
    await this.setState({ mindate: _today });
  }

  SetSMSCheck = (childData) => {
    debugger;
    this.setState({ IsSMSChecked: childData })
  }

  SetEmailCheck = (childData) => {
    this.setState({ IsEmailChecked: childData })
  }

  callbackfunction_SMSalert = (childData) => {


    var temp = this.state.newselectedSMSId;
    this.setState({ newselectedSMSId: childData })
    //this.setState({ allselectedSmsIds: (this.state.allselectedSmsIds + this.state.newselectedSMSId) })
  }

  callbackfunction_Emailalert = (childData) => {


    var temp = this.state.newselectedEmailId;
    this.setState({ newselectedEmailId: childData })
    //this.setState({ allselectedEmailIds: (this.state.allselectedEmailIds + this.state.newselectedEmailId) })
  }

  async changeVRN(selectedOption) {
    var tmpArray = [];



    await this.setState({
      VRNMappingId: selectedOption.value,
      selectedVehicle: "Vehicle: " + selectedOption.label
    });
    const data = {
      VRN: selectedOption.label,
    }
    axiosConfig.post('Portal/GetVRNInfoDetail', data)
      .then(res => {
        this.setState({

          regNo: res.data.vrnInfo[0].regNo,
          manufacturer: res.data.vrnInfo[0].manufacturer,
          vehicleName: res.data.vrnInfo[0].vehicleName,
          vehicleModelYear: res.data.vrnInfo[0].vehicleModelYear,
          vehicleEngineChasisNo: res.data.vrnInfo[0].vehicleEngineChasisNo,
          currentOdo: res.data.vrnInfo[0].currentOdo + ' Km',
          createdDate:res.data.vrnInfo[0].createdDate,
        })
      }
      )
      .catch(function (error) {
      }
      );


  }

  callbackfunction_PushAlert = (childData) => {

    this.setState({ IsPushAlert: childData })
  }
  componentDidMount() {

    this.setTodayDate();
    const data = {
      UserBranchID: this.props.data.selectedBranchId,
    };
    axiosConfig
      .post("Portal/GetVRNGroupMapping", data)
      .then((res) => {
        for (var i = 0; i < res.data.groupVRN.length; i++) {
          this.setState((prevState) => ({
            groups: [
              ...prevState.groups,
              {
                value: res.data.groupVRN[i].groupID,
                label: res.data.groupVRN[i].groupName,
                vrn: res.data.groupVRN[i].vrnModel,
              },
            ],
          }));
        }
      })
      .catch(function (error) { });


    /*Get Maintenance Activity*/
    axiosConfig
      .post("Portal/GetMaintenanceActivity")
      .then((res) => {

        for (var i = 0; i < res.data.maintenanceActivity.length; i++) {
          this.setState((prevState) => ({

            maintenanceActivity: [
              ...prevState.maintenanceActivity,
              {
                value: res.data.maintenanceActivity[i].id,
                label: res.data.maintenanceActivity[i].maintenanceActivity,
              },
            ],
          }));
        }
      })
      .catch(function (error) { });
  }
  changeGroup(selectedOption) {
    console.log(selectedOption);
    var tmpArray = [];
    console.log(tmpArray);

    this.setState(
      {
        vrnOptions: [],
      },
      function () {
        let tmpArray = this.state.groups.find(
          (groupid) => groupid.value === selectedOption.value
        );
        tmpArray.vrn.map((el, index) => {
          this.setState((prevState) => ({
            vrnOptions: [
              ...prevState.vrnOptions,
              {
                value: el.mappingID,
                label: el.vrn,
              },
            ],
          }));
        });
      }
    );
  }

  changeHandler(p) {


    console.log('target:', p.target.name);

    if (p.target.name == "ReminderOdometer" || p.target.name == "AvglastOdometerReading") {
      p.target.value = p.target.value.replace(/[^0-9]/gi, "");
    }

    if(p.target.name == "Comments" || p.target.name == "OthersActivityComments")
    {
      p.target.value = p.target.value.replace(/[^a-zA-Z0-9\s]/gi, "");     
    } 

    var newState = {};
    newState[p.target.name] = p.target.value;
    this.setState(newState);


  }
  changeHandlerDate(s) {
    let year = todayDate.getUTCFullYear()
    let month = todayDate.getUTCMonth() + 1;
    if (month < 10) { month = "0" + month }
    let day = todayDate.getDate()

    let _today = year + '-' + month + '-' + day

    var date1 = new Date(day);
    var date2 = new Date(s.target.value);

  }

  async changeHandler_GetLastOdometerReading(p) {
    await this.setState({
      ActivityDate: p.target.value
    });

    const data = {
      MappingID: this.state.VRNMappingId,
      ActivityDate: this.state.ActivityDate
    };
    axiosConfig
      .post("Portal/GetLastOdomemeter", data)
      .then((res) => {
        this.setState({
          AvglastOdometerReading: res.data.odometer
        });
      })
      .catch(function (error) { });

  }

  async handleSubmit(e) {


    /*Added By Ishfaque Kazi on 19th of May  2021*/

    e.preventDefault();
    let token = localStorage.getItem('token');
    let cards = []
    /*start*/

    let allSelectedSMSAndEmailsIDs = []

    if (this.state.newselectedSMSId.length > 0) {
      for (var i = 0; i < this.state.newselectedSMSId.length; i++) {
        let a = this.state.newselectedSMSId[i].SelectedSMSValue
        allSelectedSMSAndEmailsIDs.push(a);
      }
    }

    if (this.state.newselectedEmailId.length > 0) {
      for (var i = 0; i < this.state.newselectedEmailId.length; i++) {
        let a = this.state.newselectedEmailId[i].SelectedEmailValue
        allSelectedSMSAndEmailsIDs.push(a);
      }
    }

    await this.setState(
      {
        allSelectedSMSAndEmailsID: allSelectedSMSAndEmailsIDs
      })
    let today = this.state.ActivityDate;
    let date = "";

    var ActivityDate = this.state.ActivityDate.split("T");

    var reminderOdo = (this.state.ReminderOdometer == '') ? "0" : this.state.ReminderOdometer;

    axiosConfig.post("Portal/VehicleHealthMaintenance",
      {
        VRNMappingId: this.state.VRNMappingId,
        ActivityId: this.state.ActivityId,
        ActivityDate: ActivityDate[0] + " " + ActivityDate[1],
        AvglastOdometerReading: this.state.AvglastOdometerReading,
        ReminderDate: this.state.ReminderDate,
        ReminderOdometer: reminderOdo,
        Comments: this.state.Comments,
        UserProfileID: this.state.allSelectedSMSAndEmailsID,
        OtherActivity: this.state.OthersActivityComments,
        IsAlertChecked: this.state.IsPushAlert

      }
    )
      .then(Response => {
        Swal.fire({
          icon: 'success',
          title: 'Saved Successfully',
        })
      })
      .catch(error => {
        Swal.fire({
          title: error.response.data.errorMessage,
          text: 'Some Error !',
          icon: 'error',
          confirmButtonText: 'Okay'
        })
      })
    /*End*/

  };

  onClickNext() {
    if (this.state.currentStep < 3)
      this.setState({
        currentStep: this.state.currentStep + 1,
      });
  }

  onClickPrevious() {
    if (this.state.currentStep > 0)
      this.setState({
        currentStep: this.state.currentStep - 1,
      });
  }

  async onActivityChange(selectedOption) {

    if (selectedOption.label === "Other") {
      await this.setState({
        OthersActivity: true
      });
    }
    else {
      await this.setState({
        OthersActivity: false
      });
    }


    await this.setState({
      activityText: selectedOption.label,
      ActivityId: selectedOption.value,

    });
  }

  render() {
    const { VRNMappingId, ActivityId, ActivityDate, ReminderOdometer, ReminderDate, Comments, OthersActivityComments, AvglastOdometerReadings } = this.state;
    const { steps, currentStep } = this.state;
    const buttonStyle = {
      background: "#E0E0E0",
      width: 200,
      padding: 16,
      textAlign: "center",
      margin: "0 auto",
      marginTop: 32,
    };

    return (
      <>
        <CustomHeader></CustomHeader>
        <Row className="p-3">
          <Card className="p-3" style={{ width: "100%" }}>
            <Card.Title>
              <div className="pull-left">
                Maintanance Activities
                <br></br>
                <small>{this.state.selectedVehicle}</small>
              </div>
            </Card.Title>

            <Card.Body>
              <Stepper
                steps={steps}
                activeStep={currentStep}
                activeColor="#ffd500"
                defaultBarColor="#ffd500"
                completeColor="red"
                // completeColor="red"
                completeBarColor="#ffd500"
                defaultBorderColor="green"
              />

              {currentStep === 0 && (
                <>
                  <br></br>
                  <br></br>
                  <br></br>
                  <Row className="mb-4">
                    <Col></Col>

                    <div className="col-sm-2 col-12 p-2">
                      <div>Select Vehicle Group</div>
                    </div>

                    <div className="col-sm-3 col-12">
                      <Select
                        className=""
                        options={this.state.groups}
                        styles={customStyles}
                        onChange={this.changeGroup}
                      ></Select>
                    </div>

                    <div className="col-sm-2 col-12 p-2">
                      <div>Select Vehicle</div>
                    </div>

                    <div className="col-sm-3 col-12">
                      <Select
                        className=""
                        options={this.state.vrnOptions}
                        styles={customStyles}
                        onChange={this.changeVRN}
                      ></Select>
                    </div>
                  </Row>
                  <Row>
                    <Col>
                      <CardDeck>
                        <HomeVehicle
                          quantityPrice={this.state.regNo}
                          Icon="fa fa-road text-primary font-medium-5"
                          percentage="0"
                          description="Vehicle Registration Number"
                          cssName="avatar bg-rgba-danger p-50 m-0 mb-2"
                        />
                        <HomeVehicle
                          quantityPrice={this.state.manufacturer}
                          Icon="fa fa-credit-card font-medium-5"
                          percentage="5"
                          description="Vehicle Make"
                          cssName="avatar p-50 m-0 mb-2 avatar-blue"
                        />
                        <HomeVehicle
                          quantityPrice={this.state.vehicleName}
                          Icon="fa fa-credit-card font-medium-5"
                          percentage="5"
                          description="Vehicle Model"
                          cssName="avatar p-50 m-0 mb-2 avatar-blue"
                        />
                        <HomeVehicle
                          quantityPrice={this.state.vehicleModelYear}
                          Icon="fa fa-money text-warning font-medium-5"
                          percentage="2"
                          description="Year of Assembly"
                          cssName="avatar bg-rgba-warning p-50 m-0 mb-2"
                        />
                        <HomeVehicle
                          quantityPrice={this.state.vehicleEngineChasisNo}
                          Icon="fa fa-tint text-primary font-medium-5"
                          percentage="2"
                          description="Engine/Chasis No. "
                          cssName="avatar bg-rgba-primary p-50 m-0 mb-2"
                        />
                        <HomeVehicle
                          quantityPrice={this.state.currentOdo}
                          Icon="fa fa-database text-success font-medium-5"
                          percentage="2"
                          description="Last Odometer Reading"
                          cssName="avatar bg-rgba-success p-50 m-0 mb-2"
                        />
                      </CardDeck>
                    </Col>
                  </Row>
                </>
              )}

              {currentStep === 1 && (
                <>
                  <br></br>
                  <br></br>


                  <Row>
                    <div className="col-md-12 col-12">
                      <div className="form-group">
                        {/* <label htmlFor="ReportType">Choose Trend</label> */}
                        <p className="text-left">Choose Activity</p>
                        <Select
                          className=""
                          options={this.state.maintenanceActivity}
                          styles={customStyles}
                          onChange={this.onActivityChange}

                        ></Select>
                      </div>
                    </div>
                    {
                      this.state.OthersActivity != false &&
                      <div className="col-md-6 col-12">
                        <div className="form-label-group">                       
                            <input type="text" id="OthersActivityComments" name="OthersActivityComments" value={this.state.OthersActivityComments} onChange={this.changeHandler} className="form-control" maxLength="50" required />
                            <label htmlFor="city-column">Other's Activity </label>
                        </div>
                      </div>
                    }
                    <div className="col-md-6 col-12">
                      <div className="form-label-group">
                        <input type="datetime-local" id="ActivityDate" name="ActivityDate" value={this.state.ActivityDate} onChange={this.changeHandler_GetLastOdometerReading}  className="form-control" min={this.state.createdDate}/>
                        <label htmlFor="city-column">Pick date of last {this.state.activityText} </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-label-group">  
                        <input type="text" id="AvglastOdometerReading" name="AvglastOdometerReading" value={this.state.AvglastOdometerReading} onChange={this.changeHandler}  className="form-control" maxLength="7" readOnly />
                        <label htmlFor="city-column">Last Odometer Reading </label>
                      </div>
                    </div>


                    <div className="col-md-12 col-12">

                      {/* <VehicleHealthComponent></VehicleHealthComponent> */}
                    </div>
                  </Row>


                </>
              )}
              {currentStep === 2 && (

                <form className="form" id="form2" onSubmit={this.submitHandler}>
                  <br></br>
                  <br></br>
                  <br></br>
                  <div className="form-body">
                    <div className="row">
                      <div className="col-md-6 col-12">
                        <div className="form-label-group">
                          <input
                            type="text"
                            maxLength="7"
                            className="form-control"
                            id="ReminderOdometer" name="ReminderOdometer" value={this.state.ReminderOdometer} onChange={this.changeHandler}
                          />
                          <label>Remind me after xx kilometers</label>
                        </div>
                      </div>
                      <div className="col-md-2 col-12">
                        OR

                      </div>

                      <div className="col-md-4 col-12">
                        <div className="form-label-group">
                          <input
                            type="date"
                            id="ReminderDate" name="ReminderDate"
                            min={this.state.ActivityDate}
                            value={this.state.ReminderDate}
                            onChange={this.changeHandler}
                            className="form-control"
                          />
                          <label htmlFor="country-floating">Date</label>
                        </div>
                      </div>

                      <div className="col-md-6 col-12">
                        <div className="form-label-group">
                        <label>error</label>
                          <input
                            type="text"
                            className="form-control"
                            id="Comments"
                            name="Comments"
                            maxLength="50"
                            value={this.state.Comments}
                            onChange={this.changeHandler}
                          />
                          <label>Add comments with reminders (optional)</label>
                        </div>
                       
                      </div>


                    </div>
                  </div>
                </form>
              )}

              {currentStep === 3 && (
                <div>


                  {/* <form className="form" id="form2" onSubmit={this.submitHandler}> */}
                  <br></br>
                  <br></br>
                  <br></br>

                  <ReminderAlert
                    parentSMSCallback={this.callbackfunction_SMSalert}
                    parentEmailCallback={this.callbackfunction_Emailalert}
                    parentPushAlertDataCallback={this.callbackfunction_PushAlert}
                    IsPushAlert={this.state.IsPushAlert}
                    IsSMSChecked={this.state.IsSMSChecked}
                    IsEmailChecked={this.state.IsEmailChecked}
                    parentPushAlertSMSCallback={this.SetSMSCheck}
                    parentPushAlertEmailCallback={this.SetEmailCheck}

                  ></ReminderAlert>

                  <div className="col-12" style={{ textAlign: "center" }}>
                    <button
                      type="submit"
                      className="btn btn-shell mr-1 mb-1"
                      onClick={this.handleSubmit}
                    >
                      Save Details
                    </button>
                  </div>
                </div>
              )}

              <div>
                {this.state.currentStep != 0 &&

                  <div class="pull-left">
                    <Button
                      className="btn-shell"
                      variant="warning"
                      onClick={this.onClickPrevious}
                    >
                      Previous
                    </Button>
                  </div>
                }
                {this.state.currentStep != 3 &&

                  <div class="pull-right">
                    <Button
                      className="btn-shell"
                      variant="warning"
                      onClick={this.onClickNext}
                    >
                      Next
                    </Button>
                  </div>
                }
              </div>
            </Card.Body>
          </Card>
        </Row>
      </>
    );
  }
}

export default VehicleManagement;
